import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Button } from '../Button';
import { Typography } from '../Typography';
import styles from './BottomSheetContentLayout.module.scss';
export function BottomSheetContentLayout(props) {
    var _footer_paddingGutter, _footer_paddingGutter1, _footer_primaryAction_testId, _footer_secondaryAction_testId;
    const { children, header, footer, contentClassName, contentGutter } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": "bottom-sheet-header-slot",
                children: header && /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.header, {
                        [styles["".concat(header.gutter, "Gutter")]]: header.gutter
                    }),
                    "data-testid": "bottom-sheet-header",
                    style: {
                        paddingBottom: header.paddingBottom
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            weight: "normal",
                            testId: header.titleTestId,
                            children: header.title
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            skin: "secondary",
                            children: header.subtitle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.content, contentClassName, {
                    [styles["".concat(contentGutter, "Gutter")]]: contentGutter
                }),
                children: children
            }),
            /*#__PURE__*/ _jsx("div", {
                "data-testid": "bottom-sheet-footer-slot",
                children: footer && /*#__PURE__*/ _jsxs("div", {
                    "data-testid": "bottom-sheet-footer",
                    className: styles.footer,
                    style: {
                        paddingLeft: (_footer_paddingGutter = footer.paddingGutter) !== null && _footer_paddingGutter !== void 0 ? _footer_paddingGutter : 16,
                        paddingRight: (_footer_paddingGutter1 = footer.paddingGutter) !== null && _footer_paddingGutter1 !== void 0 ? _footer_paddingGutter1 : 16,
                        paddingTop: footer.paddingTop
                    },
                    children: [
                        footer.primaryAction && /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(Button, {
                                fluid: true,
                                roundness: "m",
                                onClick: footer.primaryAction.onClick,
                                disabled: footer.primaryAction.disabled,
                                testId: (_footer_primaryAction_testId = footer.primaryAction.testId) !== null && _footer_primaryAction_testId !== void 0 ? _footer_primaryAction_testId : 'bottom-sheet-primary-action',
                                intent: footer.primaryAction.intent,
                                loading: footer.primaryAction.loading,
                                tooltip: footer.primaryAction.tooltip,
                                bi: footer.primaryAction.bi,
                                children: footer.primaryAction.text
                            })
                        }),
                        footer.secondaryAction && /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(Button, {
                                fluid: true,
                                roundness: "m",
                                skin: "primaryOutline",
                                onClick: footer.secondaryAction.onClick,
                                disabled: footer.secondaryAction.disabled,
                                testId: (_footer_secondaryAction_testId = footer.secondaryAction.testId) !== null && _footer_secondaryAction_testId !== void 0 ? _footer_secondaryAction_testId : 'bottom-sheet-secondary-action',
                                children: footer.secondaryAction.text
                            })
                        })
                    ]
                })
            })
        ]
    });
}
